const state = {
  ...window.__initialAppState.modules.checkout
};

export default state;
